import React from 'react';
import { motion } from 'framer-motion';
import ChevronIcon from './chevron_icon';
import SeverityLevel from './security_level';
import { ReportCategoryInterface } from '../../../domain/interface/report_category_interface';
import { useTranslation } from '../../../../../i18n/useTranslation';


interface ReportTypeItemProps {
    category: ReportCategoryInterface;
    isOpen: boolean;
    selectedReportCategory: { category: ReportCategoryInterface; severity: number } | null;
    severityColors: string[];
    backgroundColor: string;
    onToggle: () => void;
    onSelectSeverity: (category: ReportCategoryInterface, severity: number) => void;
}

const ReportTypeItem: React.FC<ReportTypeItemProps> = ({ category, isOpen, selectedReportCategory, severityColors, backgroundColor, onToggle, onSelectSeverity }) => {
    const { t } = useTranslation();
    return (
    <div className="flex flex-col items-center gap-1.25">
        <div
            className="flex justify-between w-full items-center gap-2 cursor-pointer p-2.5"
            onClick={onToggle}
        >
            <span className="text-sm">{category.name}</span>
            <ChevronIcon isOpen={isOpen} />
        </div>
        
        <motion.div 
            initial={false}
            animate={{ 
                height: isOpen ? 'auto' : 0,
                opacity: isOpen ? 1 : 0,
                paddingTop: isOpen ? '0.625rem' : 0,
                paddingBottom: isOpen ? '0.625rem' : 0,
            }}
            transition={{ 
                duration: 0.3, 
                ease: [0.4, 0.0, 0.2, 1]
            }}
            className={`flex flex-col gap-2.5 px-2.5 w-full rounded-xl overflow-hidden ${isOpen ? 'mb-2.5' : ''}`}
            style={{ backgroundColor: isOpen ? backgroundColor : 'transparent' }}
        >
            <span className="text-sm">{t('vibes.report.select_severity')}</span>
            <div className="flex gap-1.75 items-center">
                {severityColors.map((color, index) => (
                    <SeverityLevel
                        key={index}
                        level={index + 1}
                        color={color}
                        isSelected={
                          selectedReportCategory?.category === category && 
                          selectedReportCategory?.severity === index + 1
                        }
                        onSelect={() => onSelectSeverity(category, index + 1)}
                    />
                ))}
            </div>
        </motion.div>
    </div>
    );
};

export default ReportTypeItem;